export default __webpack_public_path__ + "static/media/Yearbook1.bc3b0660.jpg";